module.exports = __webpack_public_path__ + "static/media/loader.5fe0e55f.gif";